/**
 * 直播 / 语音对讲失败回落：集中文案与可见错误提示（项 15）
 */
export const LIVE_VOICE_ERRORS = {
  STREAM_KEY_MISSING: '该队员未绑定推流码（stream_key），直播按钮无法亮红。请确认 devices.stream_key 迁移已执行，或令牌已绑定。',
  STREAM_KEY_COLUMN_MISSING: '库表缺 devices.stream_key 列，已降级用绑定令牌顶替；请尽快执行迁移 202610250030_add_devices_stream_key.sql',
  LIVE_PLAY_FAILED: '直播拉流失败，请检查推流是否在线或网络后重试',
  VOICE_PTT_ALLOW_FAILED: '对讲门禁写入失败，请确认队员已绑定令牌后重试',
  VOICE_PTT_ALLOW_NO_MATCH: '未匹配到有效追踪令牌，对讲门禁未写入',
  VOICE_PTT_CLEANUP_FAILED: '语音清理未完成（队员轨迹已保留）',
  VOICE_PLAY_FAILED: '语音播放失败，请检查音频格式或网络'
};

export function liveVoiceErrorMessage(code, fallback) {
  const key = String(code || '').trim();
  if (key && LIVE_VOICE_ERRORS[key]) return LIVE_VOICE_ERRORS[key];
  return fallback || LIVE_VOICE_ERRORS.LIVE_PLAY_FAILED;
}
